import { SharedGridConfig } from "app/modules/shared/ag-grid/shared-grid-state/shared-grid.model";
import { DashboardGridDatePayload } from "../models/dashboard-api.models";
import { LiveShipmentTab } from "./dashboard.model";

export class OnGetDashboardData {
  static readonly type = '[Dashboard] Get Dashboard Data';
}

export class OnSetDashboardGridConfig {
  static readonly type = '[Dashboard] Set Dashboard Grid Config';
  constructor(public payload: SharedGridConfig) { }
}

export class OnGetLiveShipmentsData {
  static readonly type = '[Dashboard] Get Live Shipments Data';
  constructor(public payload: { query: { queryType: string, startDate: string, endDate: string; }, gridUUID: string, activeTab: LiveShipmentTab }) { }
}

export class OnSwapShipmentView {
  static readonly type = '[Dashboard] Swap Shipment View';
  constructor(public payload: { tab: LiveShipmentTab, gridUUID: string; }) { }
}

export class OnGetDashboardSupplierShipments {
  static readonly type = '[Dashboard] Get Dashboard Purchase Invoices';
  constructor(public payload: DashboardGridDatePayload) { }
}

export class OnGetDashboardSalesInvoices {
  static readonly type = '[Dashboard] Get Dashboard Sales Invoices';
  constructor(public payload: DashboardGridDatePayload) { }
}

